


export const options = (t: any, translationKey: string, lang: 'ru' | 'kz') => [
  { label: t(`${translationKey}.school`, lang), value: 'true' },
  { label: t(`${translationKey}.kindergarten`, lang), value: 'false' },
]

export const conditionOptions = (t: any, translationKey: string, lang: 'ru' | 'kz') => [
  { label: t(`${translationKey}.good`, lang), value: 'GOOD' },
  { label: t(`${translationKey}.satisfactory`, lang), value: 'SATISFACTORY' },
  { label: t(`${translationKey}.bad`, lang), value: 'BAD' },
]

export const requirementsOptions = (t: any, translationKey: string, lang: 'ru' | 'kz') => [
  { label: t(`${translationKey}.not-needed`, lang), value: 'NOT_NEEDED' },
  { label: t(`${translationKey}.major-renovation`, lang), value: 'MAJOR_RENOVATION' },
  { label: t(`${translationKey}.current-renovation`, lang), value: 'CURRENT_RENOVATION' },
  { label: t(`${translationKey}.reconstruction`, lang), value: 'RECONSTRUCTION' }
]

export const yesOrNo = (t: any, translationKey: string, lang: 'ru' | 'kz') => [
  { label: t(`${translationKey}.yes`, lang), value: 'true' },
  { label: t(`${translationKey}.no`, lang), value: 'false' },
]

export const operatorOptions = (t: any, translationKey: string, lang: 'ru' | 'kz') => [
  { label: t(`${translationKey}.altel`, lang), value: 'Altel' },
  { label: t(`${translationKey}.kcell`, lang), value: 'Kcell' },
  { label: t(`${translationKey}.beeline`, lang), value: 'Beeline' },
  { label: t(`${translationKey}.activ`, lang), value: 'Activ' },
  { label: t(`${translationKey}.tele2`, lang), value: 'Tele2' },
  { label: t(`${translationKey}.kazakhtelecom`, lang), value: 'Казахтелеком' },
  { label: t(`${translationKey}.altel-4g`, lang), value: 'Altel (4G)' },
  { label: t(`${translationKey}.kcell-4g`, lang), value: 'Kcell (4G)' },
  { label: t(`${translationKey}.beeline-4g`, lang), value: 'Beeline (4G)' },
  { label: t(`${translationKey}.activ-4g`, lang), value: 'Activ (4G)' },
  { label: t(`${translationKey}.tele2-4g`, lang), value: 'Tele2 (4G)' },
  { label: t(`${translationKey}.other`, lang), value: 'other' },

]

